// extracted by mini-css-extract-plugin
module.exports = {"container":"countdown-message_container__C388t","time":"countdown-message_time__m6I1M"};